import {
 all, put, takeLatest,
} from 'redux-saga/effects';
import API_ENDPOINTS from '../../../config/API-endpoints';
import { protectedRoutes } from '../../../routes';
import { getCookie } from '../../../utils';
import { fetcherAction } from '../fetcher/creator';
import { sessionActions } from '../session/creator';
import { activeJobsActions, activeJobsConstants } from './creator';
import toaster from '../../../components/atoms/toaster';

const jobsAPI = {
  fetchJobs: (payload) => ({
    tokenize: true,
    fetcherParams: {
      method: 'POST',
      url: API_ENDPOINTS.jobSearch,
      data: payload,
    },
    headers: {
      authorization: getCookie('authToken'),
      'Content-Type': 'application/json',
    },
  }),

  fetchJobDetails: (jobId) => ({
    tokenize: true,
    fetcherParams: {
      method: 'GET',
      url: API_ENDPOINTS.jobDetails(jobId),
    },
    headers: {
      authorization: getCookie('authToken'),
      'Content-Type': 'application/json',
    },
  }),
  fetchJobSearchConfigs: (jobId) => ({
    tokenize: true,
    fetcherParams: {
      method: 'GET',
      url: API_ENDPOINTS.jobSearchConfigs(jobId),
    },
    headers: {
      authorization: getCookie('authToken'),
      'Content-Type': 'application/json',
    },
  }),
};

function* handleLocationChange({ payload }) {
  if (!payload.location.pathname.includes(protectedRoutes.activeJobs)) {
    return true;
  }
  return yield put(activeJobsActions.fetchJobs());
}

function* searchJobs({ payload: searchQuery }) {
  return yield put(
    fetcherAction({
      ...jobsAPI.fetchJobs({
        offset: 0,
        limit: 100,
        status: ['open', 'sourcing_draft', 'active', 'on_hold'],
        t500_sourcing_control: true,
        ...(searchQuery && { query: searchQuery }),
      }),
      label: activeJobsConstants.SEARCH_JOBS,
    }),
  );
}

function* searchJobsOnSuccess({ response }) {
  return yield put(activeJobsActions.setJobsInStore(response.data));
}

function* searchJobsOnFailure({ error }) {
  // logout if not not authorized
  if (error.response.status === 401) {
    return yield put(sessionActions.userLogout());
  }
  toaster({
    type: 'error',
    msg: 'Couldn\'t run the search at the moment, Please try again later',
  });
  return error;
}

function* fetchJobDetails({ payload: jobId }) {
  if (jobId) {
    return yield put(
      fetcherAction({
        ...jobsAPI.fetchJobDetails(jobId),
        label: activeJobsConstants.FETCH_JOB_DETAILS,
      }),
    );
  }
    return yield put(activeJobsActions.setSelectedJobDetails(null));
}

function* fetchJobDetailsOnSuccess({ response }) {
  yield put(activeJobsActions.getSearchConfigsForJob(response.id));
  return yield put(activeJobsActions.setSelectedJobDetails(response));
}

function* fetchJobDetailsOnFailure() {
  yield put(activeJobsActions.getSearchConfigsForJob(null));
  return yield put(activeJobsActions.setSelectedJobDetails(null));
}

function* fetchJobSearchConfigs({ payload: jobId }) {
  return yield put(
    fetcherAction({
      ...jobsAPI.fetchJobSearchConfigs(jobId),
      label: activeJobsConstants.FETCH_JOB_SEARCH_CONFIGS,
    }),
  );
}

function* fetchJobSearchConfigsOnSuccess({ response }) {
  return yield put(
    activeJobsActions.setSelectedJobDetails(
      { searchConfigs: response },
      { update: true },
    ),
  );
}

export default function* activeJobsSagas() {
  yield all([
    // takeLatest(activeJobsConstants.SEARCH_JOBS.TRIGGER, searchJobs),
    // takeLatest(activeJobsConstants.SEARCH_JOBS.SUCCESS, searchJobsOnSuccess),
    // takeLatest(activeJobsConstants.SEARCH_JOBS.FAILURE, searchJobsOnFailure),

    // takeLatest(
    //   activeJobsConstants.FETCH_JOB_SEARCH_CONFIGS.TRIGGER,
    //   fetchJobSearchConfigs,
    // ),
    // takeLatest(
    //   activeJobsConstants.FETCH_JOB_SEARCH_CONFIGS.SUCCESS,
    //   fetchJobSearchConfigsOnSuccess,
    // ),

    // takeLatest(activeJobsConstants.FETCH_JOB_DETAILS.TRIGGER, fetchJobDetails),
    // takeLatest(
    //   activeJobsConstants.FETCH_JOB_DETAILS.SUCCESS,
    //   fetchJobDetailsOnSuccess,
    // ),
    // takeLatest(
    //   activeJobsConstants.FETCH_JOB_DETAILS.FAILURE,
    //   fetchJobDetailsOnFailure,
    // ),

    // // to use below pattern, 'connected-react-router' is required in dependencies.
    // takeLatest('@@router/LOCATION_CHANGE', handleLocationChange),
  ]);
}
